import $ from 'jquery';
import each from 'lodash/each';


const ensureChildElementExists = (parent, tagname, className)=> {
  const $parent = $(parent);
  var el = $parent.find(`> ${tagname}.${className}`).get(0);

  if (!el) {
    var $el = $(`<${tagname} class="${className}" />`);
    $parent.append($el);
    el = $el.get(0);
  }

  return el;
};


const hasClassOrParent = ($el, className)=>
  $el.hasClass(className) || $el.closest(`.${className}`).length > 0;

/*
 * Parse an anchor link DOM node returning a list of attributes for that node
 *
 * @param linkEl DOM Element
 *
 * @return object
 */
const getLinkAttrsFromEl = (linkEl)=> {
  if (!linkEl || linkEl.length === 0) {
    return null;
  }

  const attrs = {};

  each(linkEl.attributes, function (attribute) {
    attrs[attribute.name] = attribute.value;
  });

  return attrs;
};

/**

  Given an `htmlString` containing html as a string, extract the
  plain text from it. 

  Note: There is no reliable way to ensure white space presevation
  and other subtleties. This is a rather "rough" display.

*/
const extractPlaintextFromHtmlString = (htmlString)=>
  $('<div>').html(htmlString).text();


/**
 * Determine if a given element is in the current viewport.
 *
 * @param el DOM element
 * @param partially bool
 *
 * @return bool
 */
const isElInViewport = (el, { partially = false })=> {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  if(partially) {
    return (
      rect.top <= windowHeight &&
      rect.left <= windowWidth &&
      (rect.top + rect.height) >= 0 &&
      (rect.left + rect.width) >= 0
    );
  }

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    (rect.top + rect.height) <= windowHeight &&
    (rect.left + rect.width) <= windowWidth
  );
};


export {
  extractPlaintextFromHtmlString,
  hasClassOrParent,
  getLinkAttrsFromEl,
  ensureChildElementExists,
  isElInViewport
};
